import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.2942 3.70313L3.64616 12.3512M14.3333 7.9974C14.3333 11.4952 11.4978 14.3307 7.99996 14.3307C6.25106 14.3307 4.66772 13.6218 3.52162 12.4757C2.37551 11.3296 1.66663 9.7463 1.66663 7.9974C1.66663 4.49959 4.50216 1.66406 7.99996 1.66406C9.74886 1.66406 11.3322 2.37295 12.4783 3.51905C13.6244 4.66516 14.3333 6.24849 14.3333 7.9974Z",
      stroke: "currentColor",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }